module.exports = __webpack_public_path__ + "img/room-cleaning.0c80ca36.jpeg";